<ng-container *ngIf="banners && banners.length === 5">
    <div
        class="banners-box mb-0"
        [ngStyle]="{ direction: lang === 'ar' ? 'rtl' : 'ltr' }"
    >
        <div
            class="first-banner"
            [ngClass]="banners[0].link_en ? 'pointer' : ''"
            (click)="openLink(0, banners[0].type)"
        >
            <div class="banner-container-wrapper ">
                <img  loading="lazy" 
                    class="mob-view"
                    [src]="
                        lang == 'en' ? banners[0].image_en : banners[0].image_ar
                    "
                    [ngClass]="banners[0].placeholder ? 'contain' : ''"
                       [alt]="
                        lang == 'en' ? banners[0].image_en : banners[0].image_ar
                    "
                    onError="this.src='./../../../assets/images/section/600x200.png';"
                />
                <img  loading="lazy" 
                    class="web-view"
                    [src]="
                        lang == 'en'
                            ? banners[0].image_web_en
                            : banners[0].image_web_ar
                    "
                    [ngClass]="banners[0].placeholder ? 'contain' : ''"
                       [alt]="
                        lang == 'en'
                            ? banners[0].image_web_en
                            : banners[0].image_web_ar
                    "
                    onError="this.src='./../../../assets/images/section/600x200.png';"
                />
                <!-- <h2>{{banners[0]?.name}}</h2> -->
            </div>
        </div>

        <div class="next-banners">
            <div
                class="banner mb-2"
                [ngClass]="banners[3].link_en ? 'pointer' : ''"
                (click)="openLink(3, banners[3].type)"
            >
                <div class="banner-container-wrapper">
                    <img  loading="lazy" 
                        class="mob-view"
                        [src]="
                            lang == 'en'
                                ? banners[3].image_en
                                : banners[3].image_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[3].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[3].image_en
                                : banners[3].image_ar
                        "
                    />
                    <img  loading="lazy" 
                        class="web-view"
                        [src]="
                            lang == 'en'
                                ? banners[3].image_web_en
                                : banners[3].image_web_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[3].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[3].image_web_en
                                : banners[3].image_web_ar
                        "
                    />
                    <!-- <h2>{{banners[3]?.name}}</h2> -->
                </div>
            </div>
            <div
                class="banner mb-2"
                [ngClass]="banners[1].link_en ? 'pointer' : ''"
                (click)="openLink(1, banners[1].type)"
            >
                <div class="banner-container-wrapper">
                    <img  loading="lazy" 
                        class="mob-view"
                        [src]="
                            lang == 'en'
                                ? banners[1].image_en
                                : banners[1].image_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[1].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[1].image_en
                                : banners[1].image_ar
                        "
                    />
                    <img  loading="lazy" 
                        class="web-view"
                        [src]="
                            lang == 'en'
                                ? banners[1].image_web_en
                                : banners[1].image_web_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[1].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[1].image_web_en
                                : banners[1].image_web_ar
                        "
                    />
                    <!-- <h2>{{banners[1]?.name}}</h2> -->
                </div>
            </div>
            <div
                class="banner"
                [ngClass]="banners[4].link_en ? 'pointer' : ''"
                (click)="openLink(4, banners[4].type)"
            >
                <div class="banner-container-wrapper">
                    <img  loading="lazy" 
                        class="mob-view"
                        [src]="
                            lang == 'en'
                                ? banners[4].image_en
                                : banners[4].image_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[4].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[4].image_en
                                : banners[4].image_ar
                        "
                    />
                    <img  loading="lazy" 
                        class="web-view"
                        [src]="
                            lang == 'en'
                                ? banners[4].image_web_en
                                : banners[4].image_web_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[4].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[4].image_web_en
                                : banners[4].image_web_ar
                        "
                    />
                    <!-- <h2>{{banners[4]?.name}}</h2> -->
                </div>
            </div>
            <div
                class="banner "
                [ngClass]="banners[2].link_en ? 'pointer' : ''"
                (click)="openLink(2, banners[2].type)"
            >
                <div class="banner-container-wrapper">
                    <img  loading="lazy" 
                        class="mob-view"
                        [src]="
                            lang == 'en'
                                ? banners[2].image_en
                                : banners[2].image_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[2].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[2].image_en
                                : banners[2].image_ar
                        "
                    />
                    <img  loading="lazy" 
                        class="web-view"
                        [src]="
                            lang == 'en'
                                ? banners[2].image_web_en
                                : banners[2].image_web_ar
                        "
                        onError="this.src='./../../../assets/images/section/600x300.png';"
                        [ngClass]="banners[2].placeholder ? 'contain' : ''"
                           [alt]="
                            lang == 'en'
                                ? banners[2].image_web_en
                                : banners[2].image_web_ar
                        "
                    />
                    <!-- <h2>{{banners[2]?.name}}</h2> -->
                </div>
            </div>
        </div>
    </div>
</ng-container>
